import React from 'react';
import {useIntl} from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import {AppButton} from '@components/Core/buttons/AppButton/AppButton';
import {AppOutlinedButton} from '@components/Core/buttons/AppOutlinedButton/AppOutlinedButton';
import classnames from 'classnames';
import './confirmationModal.less';

interface ConfirmationModalProps {
    className?: string;
    isOpen: boolean;
    titleKey?: string;
    noBtnKey?: string;
    yesBtnKey?: string;
    descriptionKeys?: string[];
    descriptionKeysVariables?: Record<string, any>[];
    setIsOpen?: (isOpen: boolean) => void;
    onConfirm?: () => void;
    onDecline?: () => void;
    id?: string;
    dataWdio?: string;
    noBtnId?: string;
    yesBtnId?: string;
    /** Extra content under the descriptions, e.g. a choice the confirmation depends on. */
    children?: React.ReactNode;
}

export default function ConfirmationModal({
    className,
    isOpen,
    titleKey,
    noBtnKey = 'esl.generic.no',
    yesBtnKey = 'esl.generic.yes',
    descriptionKeys = [],
    descriptionKeysVariables = [],
    setIsOpen = () => {},
    onConfirm = () => {},
    onDecline = () => {},
    id = '',
    dataWdio = '',
    noBtnId = '',
    yesBtnId = '',
    children = null
}: ConfirmationModalProps) {
    const intl = useIntl();
    const classNames = classnames('confirmation-modal', className, {
        'is-open': isOpen
    });

    function closeConfimationModal() {
        setIsOpen(false);
    }

    function handleConfirm() {
        closeConfimationModal();

        if (onConfirm) {
            onConfirm();
        }
    }

    function handleDecline() {
        closeConfimationModal();

        if (onDecline) {
            onDecline();
        }
    }

    return (
        <Dialog
            maxWidth="md"
            open={isOpen}
            classes={{root: classNames}}
            PaperProps={{
                id,
                'data-wdio': dataWdio
            } as React.HTMLAttributes<HTMLDivElement>}
        >
            {titleKey && (
                <DialogTitle>
                    {intl.formatMessage({id: titleKey, defaultMessage: ''})}
                </DialogTitle>
            )}
            <DialogContent>
                {descriptionKeys.map((key, idx) => (
                    <p className="description-msg" key={key}>
                        {intl.formatMessage(
                            {id: key, defaultMessage: ''},
                            descriptionKeysVariables[idx] || {}
                        )}
                    </p>
                ))}
                {children}
            </DialogContent>
            <DialogActions>
                <AppOutlinedButton
                    onClick={handleDecline}
                    className="no-btn"
                    data-focus-id={noBtnId}
                    data-wdio="test-confirmation-no-btn"
                >
                    {intl.formatMessage({id: noBtnKey, defaultMessage: ''})}
                </AppOutlinedButton>
                <AppButton
                    onClick={handleConfirm}
                    className="yes-btn"
                    data-focus-id={yesBtnId}
                    data-wdio="test-confirmation-yes-btn"
                    autoFocus
                >
                    {intl.formatMessage({id: yesBtnKey, defaultMessage: ''})}
                </AppButton>
            </DialogActions>
        </Dialog>
    );
}
